import { NavLink } from "react-router-dom";
import { Badge } from "@/components/ui/Badge";
import { cn } from "@/lib/cn";

const links = [
  { to: "/", label: "Home" },
  { to: "/dashboard", label: "Dashboard" },
  { to: "/characters/new", label: "Criar personagem" },
  { to: "/settings", label: "Configurações" }
];

export function MainNav() {
  return (
    <header className="sticky top-0 z-20 border-b border-gold/10 bg-midnight/75 backdrop-blur-xl">
      <div className="mx-auto flex w-full max-w-7xl flex-col gap-4 px-4 py-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-2">
            <p className="text-xs uppercase tracking-[0.32em] text-gold/85">
              Crônicas de Arton
            </p>
            <div className="flex flex-wrap items-center gap-3">
              <h1 className="text-2xl sm:text-3xl">Forja de Personagens</h1>
              <Badge tone="wine">100% local</Badge>
            </div>
          </div>
          <p className="max-w-md text-sm leading-6 text-mist">
            Criação, edição e gerenciamento de fichas direto no navegador, com
            persistência local e arquitetura pronta para modo offline completo.
          </p>
        </div>

        <nav className="flex flex-wrap gap-2">
          {links.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              className={({ isActive }) =>
                cn(
                  "rounded-full border px-4 py-2 text-sm tracking-wide text-mist transition",
                  isActive
                    ? "border-gold/45 bg-gold/12 text-parchment"
                    : "border-gold/10 bg-black/10 hover:border-gold/25 hover:text-parchment",
                )
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
